import { useState, useEffect } from 'react';
import { getApiVersion } from '@/lib/api';

/**
 * Hook to fetch the API version from the health endpoint.
 * Fetches once on mount and returns the version string or null if unavailable.
 */
export function useApiVersion(): string | null {
  const [version, setVersion] = useState<string | null>(null);

  useEffect(() => {
    getApiVersion().then(setVersion);
  }, []);

  return version;
}
